export default {
  label: 'Autores',
  placeholder: 'Todos',
  other: 'outro',
  others: 'outros',
  all: 'Todos',
  filtered: 'filtrado',
  filteredPlural: 'filtrados',
  negated: 'negativado',
  negatedPlural: 'negativados',
};
